define(
  'paginationHandler',[
    'builderShowcaseObserver',
    'event'
  ],
  (builderShowcaseObserver) => {
    'use strict';

    function PaginationHandler() {
    }

    function PaginationInitHandler() {
    }

    /**
    * @private
    * PageChanged:manage when the user change the page.
    *
    */
    function PageChanged(data) {
      data.preventDefault();
      const pageNumber = data.currentTarget.dataset.pageNumber;
      const pageUrl = data.currentTarget.href.replace(/^.*\/\/[^/]+/, '');
      const updatedSearchParams = {
        PageNumber: Number(pageNumber)
      };

      builderShowcaseObserver.setParameters(updatedSearchParams);
      builderShowcaseObserver.commit();
      const state = builderShowcaseObserver.getState();
      state.data.ReviewSearchParams.PageNumber = Number(pageNumber);
      state.filterType = 'pagination';
      window.history.pushState({}, null, pageUrl);
      builderShowcaseObserver.PaginationChanged(state);
    }

    /**
    * @private
    * SetListenersPagination: adds listeners related to pagination.
    *
    */
    function SetListenersPagination() {
      const starFilterList = document.querySelectorAll('[data-component="page-element"]');
      starFilterList.forEach((el) => { el.addEventListener('click', PageChanged); });
    }

    const events = {
      PageChanged: {
        callbacks: [PageChanged],
        elements: '[data-component="filter-by-star"]',
        events: ['change'],
      },
    };

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    PaginationHandler.update = function PageValueChanged(data) {
      PageChanged(data);
    };

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    PaginationInitHandler.update = function SetListeners() {
      SetListenersPagination();
    };

    SetListenersPagination();
    window.NewHomeSource.Event(events);
    builderShowcaseObserver.subscribe('onReviewsSectionLoaded', PaginationInitHandler);
  }

);

